import { render, staticRenderFns } from "./POptionGroup.vue?vue&type=template&id=78f49bf6"
import script from "./POptionGroup.vue?vue&type=script&lang=js"
export * from "./POptionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports